module.exports = __webpack_public_path__ + "static/media/icons_Bilan général.db5b1863.svg";